export default "__VITE_ASSET__BWtuL1UD__"